<template>
  <v-layout fill-height column>
    <div class="question">각각의 감정의 정도를 선택해주세요.</div>
    <v-layout justify-center align-center class="answer">
      <div class="thermometer-container">
        <Thermometer :emotionChoiceArr="emotionChoiceList"
                     :cmplt="cmplt"
                     @emotionChoice="emotionSelected" ref="Thermometer"/>
      </div>
    </v-layout>
    <FooterBtnsNext @before="$emit('before')" @next="setMemberReply" :current="current" :total="total"
                    :disabledNext="disabledNext"/>
  </v-layout>
</template>
<script>
import store from '@/store'
import FooterBtnsNext from "@/components/btns/FooterBtnsNext";
import Thermometer from '@/components/solution/Thermometer'

export default {
  components: {
    FooterBtnsNext,
    Thermometer,
  },
  props: ["current", "total", "unitUseNo", "unitDtlUseList", "freeYn", "cmpltYn", "unitDtlUseNo", "unitDtlPageSeq"],
  data: () => ({
    disabledNext: true,
    free: 'N',
    cmplt: false,
    ques: [],
    replyArr: [],
    replyObjArr: [],
    userReplyNo: [],
    userReply: [],
    emotionList: [],
    emotionTitleCd: 'SU008',
    emotionDetailCd: 'SU009',
    emotionSelectList: [],
    emotionValueList: [],
    emotionChoiceList: [],
    emotionChoiceScoreList: [],
  }),
  computed: {},
  watch: {
    emotionChoiceList() {
      this.$refs.Thermometer.thermometerArr = this.emotionChoiceList
    },
    emotionChoiceScoreList() {
      this.$refs.Thermometer.thermometerArrScore = this.emotionChoiceScoreList

      var disabled = 0
      this.emotionChoiceScoreList.forEach((val) => {
        if (val <= 0) {
          disabled += 1
        }
      })

      if (disabled == 0) {
        this.disabledNext = false;
      } else {
        this.disabledNext = true;
      }
    }
  },
  created() {
    this.getTravelEmotionList()
  },
  mounted() {
    setTimeout(() => this.getUnitDetailUse(), 100); // 감정 조회 이후
  },
  methods: {
    async getTravelEmotionList() {
      await store.dispatch('getTravelEmotionList', this.$_payload('so', [
        {'emotionTitleCd': this.emotionTitleCd},
        {'emotionDetailCd': this.emotionDetailCd}
      ]))
        .then(res => {
          if (res.success) {
            this.emotionList = res.data;
            // this.getStepLoadData();
          } else {
            console.log(res.msg)
            this.emotionList = []
          }
        })
        .catch(error => {
          console.error(error)
          this.emotionList = []
        })
        .finally(() => {
        })
    },
    async getUnitDetailUse() {
      // 무료 여부
      this.free = this.freeYn
      // 완료 여부
      this.cmplt = this.cmpltYn
      // this.cmplt = true
      await store.dispatch('getUnitDetailUse', this.$_payload('so',
          [{'unitUseNo': this.unitUseNo},
            {'unitDtlUseNo': this.unitDtlUseNo[this.current - 1]},
            {'unitDtlPageSeq': this.unitDtlPageSeq[this.current - 1]},
            {'freeYn': this.free},
            {'feedbackUserKey': this.$route.query.feedbackUserKey}
          ]))
        .then(res => {
          if (res.success) {

            // 질문 리스트
            res.data.unitDtlQuesList.forEach((quesEl, i) => {

              // 질문 셋팅
              // this.ques[i] = quesEl.ques
              this.ques.push(quesEl.ques)
              // this.maxSelect = quesEl.selectCnt

              // 답변 셋팅
              quesEl.unitDtlReplyList.forEach((replyEl) => {
                this.replyArr.push(replyEl.reply)
                this.replyObjArr.push(replyEl)
              });

              // // 유저 답변 셋팅
              if (quesEl.memberUnitDtlReplyList.length > 0) {
                quesEl.memberUnitDtlReplyList.forEach((userReplyEl, j) => {
                  this.userReplyNo[i + j] = userReplyEl.memberUnitDtlReplyUseNo
                  this.emotionSelectList.push(userReplyEl.reply)

                  var score = userReplyEl.score
                  if (score == null) score = 0
                  this.emotionValueList.push(score)
                });

                this.emotionSelectList.forEach((value) => {
                  this.emotionList.forEach((highCode) => {
                    highCode.detailCodeList.forEach((code) => {
                      if (code.cd == value) {
                        var emotion = {color: '', cd: '', cdNm: ''}

                        emotion.color = highCode.descCont
                        emotion.cd = code.cd
                        emotion.cdNm = code.cdNm

                        this.emotionChoiceList.push(emotion)
                      }

                    })
                  })
                })

                this.emotionChoiceScoreList = this.emotionValueList
              }
            });

          } else {
            console.log(res.msg)
            // this.answer = [];
          }
        })
        .catch(error => {
          console.error(error)
          // this.answer = [];
        })
        .finally(() => {
        })
    },
    async setMemberReply() {

      if (!this.cmplt) { // 완료상태가 아닐때만 저장
        // 유저 답변 셋팅
        let replyObj = this.replyObjArr[0]
        this.emotionSelectList.forEach((val, i) => {

          this.userReply[i] = {
            unitId: replyObj.unitId,
            sltUnitMappingUseNo: replyObj.sltUnitMappingUseNo,

            memberUnitDtlReplyUseNo: this.userReplyNo[i],
            // unitUseNo: replyObj.unitUseNo,
            unitNo: replyObj.unitNo,
            // unitDtlUseNo: replyObj.unitDtlUseNo,
            unitDtlNo: replyObj.unitDtlNo,
            // unitDtlQuesUseNo: replyObj.unitDtlQuesUseNo,
            unitDtlQuesNo: replyObj.unitDtlQuesNo,
            // unitDtlReplyUseNo: replyObj.unitDtlReplyUseNo,
            unitDtlReplyNo: replyObj.unitDtlReplyNo,
            userKey: this.$store.state.auth.authUser.userKey,
            reply: val,
            score: this.emotionValueList[i],
            freeYn: this.free,
            // unitType:"03",
          }
        })
        await store.dispatch('setMemberReply', this.$_payload('memberReplyList', this.userReply))
          .then(res => {
            if (res.success) {
              setTimeout(() => this.$emit('next'), 500); // 저장한 이후
            } else {
              console.log(res.msg)
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      } else {
        this.$emit('next')
      }
    },
    emotionSelected(emotionCd, emotionValue) {
      this.emotionSelectList.forEach((value, i) => {
        if (value == emotionCd) {
          this.emotionValueList[i] = emotionValue
        }
      })
    }
  }
};
</script>
